<div class="avi-health-score-body">
    <ng-container *ngIf="healthScore">
        <div class="avi-health-score-body__trending-score-label">
            {{ l10nKeys.trendingScoreLabel | vtranslate }}
        </div>
        <div class="avi-health-score-body__sparkline-graph">
            <clr-spinner
                *ngIf="isLoading;else areaChartRef"
                clrSmall
            ></clr-spinner>
            <ng-template #areaChartRef>
                <avi-area-chart
                    *ngIf="hsSeries && operationStatus"
                    [hsSeries]="hsSeries"
                    [class]="healthScore.health_score | healthScoreClass: operationStatus.state"
                ></avi-area-chart>
            </ng-template>
        </div>
        <avi-health-score-bars
            [healthScore]="healthScore"
            [objectName]="objectName"
        ></avi-health-score-bars>

        <hr 
            *ngIf="objectNameValue"
            class="avi-health-score-bars__partition-line">

        <div 
            *ngIf="objectNameValue"
            class="avi-health-score-body__app-security"
        >
            
            <div class="avi-health-score-body__app-security__shield-wrapper">
                <cds-icon 
                    shape="shield" 
                    [solid]="appSecurity && !appSecurityStatus"
                ></cds-icon>
                <span>
                    {{ l10nKeys.appSecurityLabel | vtranslate }} {{ appSecurityStatus }}
                </span>
                <avi-tooltip-icon-with-content-wrapper
                    status="info"
                    shape="info-circle"
                    size="20"
                >
                    {{ appSecurity ? (l10nKeys.appSecurityInfoEnableLabel | vtranslate) : (l10nKeys.appSecurityInfoDeactivatedLabel | vtranslate) }}
                </avi-tooltip-icon-with-content-wrapper>
            </div>

            <span
                [class]="appSecurity ? 'avi-health-score-body__app-security__enabled' : 'avi-health-score-body__app-security__deactivated'"
            >{{ appSecurity ? (l10nKeys.enabledLabel | vtranslate) : (l10nKeys.deactivatedLabel | vtranslate) }}</span>
            
        </div>
    </ng-container>
</div>
